import { render } from "./followerAlongNav.vue?vue&type=template&id=219f5767&scoped=true"
import script from "./followerAlongNav.vue?vue&type=script&lang=js"
export * from "./followerAlongNav.vue?vue&type=script&lang=js"

import "./followerAlongNav.vue?vue&type=style&index=0&id=219f5767&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219f5767"]])

export default __exports__